import React, { useState } from "react";
import Icon from "components/AppIcon";
import AppImage from "components/AppImage";

const ProductImageGallery = ({ images = [], productName }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const imageArray = Array.isArray(images) ? images : [images].filter(Boolean);

  const displayImages =
    imageArray?.length > 0 ? imageArray : ["/assets/images/no_image.png"];

  const handlePrevious = () => {
    setCurrentImageIndex((prev) =>
      prev === 0 ? displayImages?.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentImageIndex((prev) =>
      prev === displayImages?.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <div className="space-y-4">
      <div className="relative bg-surface rounded-lg overflow-hidden border border-border">
        <div className="aspect-square relative p-4">
          <AppImage
            src={displayImages[currentImageIndex]}
            alt={`${productName} - Image ${currentImageIndex + 1}`}
            className={`w-full h-full object-contain cursor-pointer transition-transform duration-300 scale-100`}
          />

          {displayImages?.length > 1 && (
            <>
              <button
                onClick={handlePrevious}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/50 text-white rounded-full flex items-center justify-center hover:bg-black/70 transition-colors"
                aria-label="Previous image"
              >
                <Icon name="ChevronLeft" size={20} />
              </button>
              <button
                onClick={handleNext}
                className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/50 text-white rounded-full flex items-center justify-center hover:bg-black/70 transition-colors"
                aria-label="Next image"
              >
                <Icon name="ChevronRight" size={20} />
              </button>
            </>
          )}
        </div>
      </div>

      {displayImages?.length > 1 && (
        <div className="flex space-x-2 overflow-x-auto pb-2">
          {displayImages.map((image, index) => (
            <button
              key={index}
              onClick={() => setCurrentImageIndex(index)}
              className={`flex-shrink-0 w-16 h-16 rounded-md overflow-hidden border-2 transition-colors ${
                currentImageIndex === index
                  ? "border-primary"
                  : "border-border hover:border-secondary-300"
              }`}
            >
              <AppImage
                src={image}
                alt={`${productName} thumbnail ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
      )}

      {displayImages?.length > 1 && (
        <div className="text-center text-sm text-text-secondary">
          {currentImageIndex + 1} of {displayImages?.length}
        </div>
      )}
    </div>
  );
};

export default ProductImageGallery;
